import localization from './localization'

export * from './localization'
export default localization
